// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'


import { string } from 'yup';

const obj =  {
	field:[
		{ 
			title: "Topic or Keyword", 
			attr: "language",  
			value: "", 
			placeholder: "Fitness, Weight loss, Exercise", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

			id:"topicOrkeyword",
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Target audience", 
			attr: "content",  
			value: "", 
			id:"targetAudience",
			placeholder: "Health enthusiasts, Athletes, Fitness professionals", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Target audience is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Tone", 
			attr: "content",  
			value: "", 
			id:"tone",
			placeholder: "Professional, motivational, instructional", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Specific section", 
			attr: "content",  
			value: "", 
			id:"specificSection",
			placeholder: "Homepage, About us, Blog/Articles page", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Specific section is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
		{ 
			title: "Content length", 
			attr: "content",  
			value: 250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("No Of Tokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
		{ 
			title: "Topic or Keyword", 
			attr: "language",  
			value: "Weight loss", 
			placeholder: "Fitness, Weight loss, Exercise", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

			id:"topicOrkeyword",
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Target audience", 
			attr: "content",  
			value: "Health enthusiasts", 
			id:"targetAudience",
			placeholder: "Health enthusiasts, Athletes, Fitness professionals", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Target audience is Required "),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Tone", 
			attr: "content",  
			value: "Motivational", 
			id:"tone",
			placeholder: "Professional, motivational, instructional", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Specific section", 
			attr: "content",  
			value: "Homepage, About us", 
			id:"specificSection",
			placeholder: "Homepage, About us, Blog/Articles page", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Specific section is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
		{ 
			title: "Content length", 
			attr: "content",  
			value:250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("No Of Tokens is  Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:` 
        Welcome to Weight Loss For Health Enthusiasts!\nWe are here to help you achieve your weight loss goals and become the healthiest version of yourself. Our mission is to provide you with the knowledge, tools and motivation to reach your goals. We understand how difficult it can be to make lifestyle changes, but we believe that with our support and guidance, you can succeed in reaching a healthier and happier lifestyle.\n Our team of experts will provide you with tips on nutrition, exercise plans, advice on healthy habits, recipes for nutritious meals and more. We want to offer a comprehensive approach that takes into account both physical and mental health. With our help, you will be able to make lasting changes that will lead you towards achieving your desired results.
        \nWe are passionate about helping others reach their wellness goals so don’t hesitate any longer – start today!\nAbout Us Section:\nAt Weight Loss For Health Enthusiasts we are dedicated to helping people achieve their weight loss goals through education, motivation and support. Our team consists of experienced professionals who have years of experience in the health industry as well as personal trainers who specialize in weight loss programs tailored for each individual `
        
       
       
        
	}
	}
	
	
	export default obj
	
	